import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { FormTransformers } from '@/common/utils/formTransformers'
import { useDeleteGovernmentAllocationProductDistribution } from '@/features/governmentAllocations/hooks/useDeleteGovernmentAllocationProductDistribution'
import { useQueryClient } from '@tanstack/react-query'
import { Trash2Icon } from 'lucide-react'
import { useState } from 'react'

interface GovernmentAllocationProductDistributionDeleteModalProps {
  productDistributionId?: string
}

export const GovernmentAllocationProductDistributionDeleteModal = ({
  productDistributionId,
}: GovernmentAllocationProductDistributionDeleteModalProps) => {
  const queryClient = useQueryClient()

  const [isOpen, setIsOpen] = useState(false)
  const [messages, setMessages] = useState<string[] | boolean>(false)

  const onSuccess = () => {
    setIsOpen(false)
    queryClient.invalidateQueries({ queryKey: ['companyGovernmentAllocation'] })
    queryClient.invalidateQueries({ queryKey: ['governmentAllocationsDistributions'] })
    queryClient.invalidateQueries({ queryKey: ['governmentAllocationsBranchesToDistribute'] })
    queryClient.invalidateQueries({ queryKey: ['governmentAllocationsAllowedCategoriesAndProducts'] })
  }

  const { mutate: deleteProductDistribution, isPending: deleteProductDistributionIsPending } =
    useDeleteGovernmentAllocationProductDistribution({
      onSuccess,
      onError: (error) => {
        setIsOpen(false)
        FormTransformers.errorsTransformer({ setMessages })(error)
      },
    })

  return (
    <>
      <Modal
        Trigger={
          <Button
            type="button"
            variant="outline-error"
            className="size-10 p-0"
            operationKlassToCheckPermission="Client::Billing::GovernmentAllocationProductDistributions::Stale"
          >
            <Trash2Icon strokeWidth={1} />
          </Button>
        }
        triggerAsChild
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title="Você tem certeza?"
        showClose={false}
        useCancellableFooter
        confirmButtonText="Remover produto"
        disabled={deleteProductDistributionIsPending}
        confirmButtonIsLoading={deleteProductDistributionIsPending}
        onConfirm={() => deleteProductDistribution(productDistributionId)}
      />

      <ModalMessageSimple messages={messages} setMessages={setMessages} isError />
    </>
  )
}
